<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { blur } from 'svelte/transition';

    import { api } from '../../../stores/api';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import WarehouseOne from './AccountOne.svelte';
    import { filter } from '../../../stores/filter';
    import MessageFiltered from '../../shared/MessageFiltered.svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import Separator from '../../shared/Separator.svelte';
    import MessageNotFound from '../../shared/Messages/MessageNotFound.svelte';
    import { Account } from './Account';
    import type { AccountApp } from './AccountApp';
    import { defaultAccount } from './defaultAccount';
    import AccountOne from './AccountOne.svelte';
    import type { MapLayerOneType } from '../../utilities/MapLayer/MapLayerApi';
    import { MapLayerApi } from '../../utilities/MapLayer/MapLayerApi';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import SwitchBar from '../../shared/SwitchBar/SwitchBar.svelte';
    import { SwitchBarApp } from '../../shared/SwitchBar/SwitchBarApp';

    export let addMode: boolean = false;
    export let showFilter: boolean = false;
    export let ap: AccountApp;
    export let account: Account | null = null;

    const compactMode = false;

    let error: string = '';
    let loading: boolean = true;

    let expandedIndex: string = '';

    let allItems: Account[] = [];
    let filteredItems: Account[] = [];
    let allMapLayers: MapLayerOneType[] = [];

    export let switchBarApp: SwitchBarApp;

    // let switchBarApp: SwitchBarApp = (new SwitchBarApp()).setItems([
    //     { id: 'all', label: 'Wszystkie konta' },
    //     { id: 'standard', label: 'Standardowe' },
    //     { id: 'technical', label: 'Techniczne' },
    // ]).selectItem('standard');

    async function reloadData(reset: boolean = false) {
        loading = true;
        if (reset) {
            await ap.prepareData(get(api));
        }
        allItems = await ap.getAllItems();
        filteredItems = await ap.getFilteredItems('');
        loading = false;
    }

    onMount(() => {
        reloadData();
        new MapLayerApi($api)
            .getAll()
            .then(layers => {
                allMapLayers = layers;
            })
            .catch(error => {
                console.error('Error loading map layers:', error);
            });
    });

    $: {
        console.log('filter.accounts.query', $filter.accounts.query);
        ap.getFilteredItems(
            $filter.accounts.query,
            switchBarApp.isItemSelected('technical') || switchBarApp.isItemSelected('all'),
            switchBarApp.isItemSelected('standard') || switchBarApp.isItemSelected('all')
        )
            .then(res => {
                filteredItems = res;
            })
            .catch(err => {
                console.warn('Nie udało się przefiltrować kont:', err);
                // Zachowaj poprzedni stan filteredItems w przypadku błędu
            });
    }

    $: {
        ap.getAllItems()
            .then(res => {
                allItems = res;
            })
            .catch(err => {
                console.warn('Nie udało się pobrać wszystkich kont:', err);
                // Nie aktualizuj allItems w przypadku błędu, zachowaj poprzedni stan
            });
    }
</script>

{#if loading}
    <Spinner />
{:else if addMode}
    <main style="margin-bottom: 20px;">
        <div data-type="new" style="width: 100%;">
            {#if account}
                <AccountOne
                    {account}
                    bind:ap
                    bind:addMode
                    onAdd={webuser_id => {
                        reloadData(true)
                            .then(() => {
                                account =
                                    allItems.find(acc => acc.getWebuserId() === webuser_id) || null;
                                if (account) {
                                    expandedIndex = account.innerId;
                                    addMode = false;
                                }
                            })
                            .catch(err => {
                                error = err.message || 'Error loading accounts';
                            });
                    }}
                />
            {/if}
        </div>
    </main>
{:else if error}
    <MessageDanger {error} />
{:else if allItems.length === 0}
    <MessageNotFound text={$_('no_accounts')} />
{:else}
    <!--    <div style="max-width: 300px;">-->
    <!--        <SwitchBar bind:switchBarApp onChange={(id)=>{-->
    <!--            switchBarApp = switchBarApp;-->
    <!--        }}/>-->
    <!--    </div>-->
    <Separator />
    <div class="warehouse-list">
        {#each filteredItems as account, index (account.innerId)}
            <div out:blur>
                <AccountOne
                    showHeader={index === 0}
                    {account}
                    {allMapLayers}
                    bind:ap
                    bind:expandedIndex
                    onAdd={() => {
                        reloadData(true);
                    }}
                />
            </div>
        {:else}
            <div
                style="display: flex; justify-content: center; align-items: center; flex-direction: column; padding: 30px;"
            >
                <MessageNotFound text={$_('no_filtered_accounts')} />
            </div>
        {/each}
    </div>
{/if}

<style>
    main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        /*background-color: var(--section-background);*/
        width: auto;
        height: auto;
        border-radius: 10px;
        padding: 15px;
        row-gap: 3px;
    }

    .warehouse-list {
        overflow-y: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
</style>
